export default {
  props: {
    to: [String, Object],
    replace: Boolean,
    append: Boolean,
    activeClass: String,
    exact: Boolean,
    event: [String, Array],
    exactActiveClass: String,
  },
}
